"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitType = exports.SystemUserAcl = void 0;
var SystemUserAcl;
(function (SystemUserAcl) {
    SystemUserAcl["admin"] = "admin";
    SystemUserAcl["installer"] = "installer";
    SystemUserAcl["manager"] = "manager";
    SystemUserAcl["reader"] = "reader";
    SystemUserAcl["writer"] = "writer";
})(SystemUserAcl = exports.SystemUserAcl || (exports.SystemUserAcl = {}));
var UnitType;
(function (UnitType) {
    UnitType["accelerometer"] = "accelerometer";
    UnitType["analogInput"] = "analogInput";
    UnitType["analogOutput"] = "analogOutput";
    UnitType["analogOutputHeating"] = "analogOutputHeating";
    UnitType["analogOutputLamp"] = "analogOutputLamp";
    UnitType["area"] = "area";
    UnitType["areaGroup"] = "areaGroup";
    UnitType["asset"] = "asset";
    UnitType["battery"] = "battery";
    UnitType["building"] = "building";
    UnitType["camera"] = "camera";
    UnitType["cameraSurveillance"] = "cameraSurveillance";
    UnitType["carbonDioxide"] = "carbonDioxide";
    UnitType["chair"] = "chair";
    UnitType["cleaningRound"] = "cleaningRound";
    UnitType["conferenceRoom"] = "conferenceRoom";
    UnitType["conferenceTable"] = "conferenceTable";
    UnitType["connection"] = "connection";
    UnitType["desk"] = "desk";
    UnitType["dispenser"] = "dispenser";
    UnitType["dispenserGroup"] = "dispenserGroup";
    UnitType["dispenserSoap"] = "dispenserSoap";
    UnitType["dispenserTowel"] = "dispenserTowel";
    UnitType["distance"] = "distance";
    UnitType["door"] = "door";
    UnitType["energyMeter"] = "energyMeter";
    UnitType["facility"] = "facility";
    UnitType["floor"] = "floor";
    UnitType["footfall"] = "footfall";
    UnitType["force"] = "force";
    UnitType["garage"] = "garage";
    UnitType["gateway"] = "gateway";
    UnitType["genericDevice"] = "genericDevice";
    UnitType["gyro"] = "gyro";
    UnitType["heartRate"] = "heartRate";
    UnitType["humidity"] = "humidity";
    UnitType["illuminance"] = "illuminance";
    UnitType["input"] = "input";
    UnitType["inputEnergyMeter"] = "inputEnergyMeter";
    UnitType["inputLock"] = "inputLock";
    UnitType["inputMetering"] = "inputMetering";
    UnitType["inputMotion"] = "inputMotion";
    UnitType["inputOnOff"] = "inputOnOff";
    UnitType["inputOutput"] = "inputOutput";
    UnitType["inputPowerCut"] = "inputPowerCut";
    UnitType["inputSmoke"] = "inputSmoke";
    UnitType["lab"] = "lab";
    UnitType["location"] = "location";
    UnitType["locationBurglar"] = "locationBurglar";
    UnitType["locationSmoke"] = "locationSmoke";
    UnitType["log"] = "log";
    UnitType["openClosed"] = "openClosed";
    UnitType["output"] = "output";
    UnitType["outputGate"] = "outputGate";
    UnitType["outputGeneric"] = "outputGeneric";
    UnitType["outputHeating"] = "outputHeating";
    UnitType["outputLamp"] = "outputLamp";
    UnitType["outputLock"] = "outputLock";
    UnitType["outputSiren"] = "outputSiren";
    UnitType["particulateMatter"] = "particulateMatter";
    UnitType["peopleCounter"] = "peopleCounter";
    UnitType["physicalOrChassis"] = "physicalOrChassis";
    UnitType["powerMeter"] = "powerMeter";
    UnitType["powerMonitor"] = "powerMonitor";
    UnitType["pressure"] = "pressure";
    UnitType["projector"] = "projector";
    UnitType["pulseBand"] = "pulseBand";
    UnitType["pvx"] = "pvx";
    UnitType["rain"] = "rain";
    UnitType["recycleBin"] = "recycleBin";
    UnitType["remoteGateway"] = "remoteGateway";
    UnitType["restroom"] = "restroom";
    UnitType["room"] = "room";
    UnitType["shedEstablishment"] = "shedEstablishment";
    UnitType["snowMeter"] = "snowMeter";
    UnitType["soundClassifier"] = "soundClassifier";
    UnitType["soundPressureLevel"] = "soundPressureLevel";
    UnitType["spaceother"] = "spaceother";
    UnitType["spot"] = "spot";
    UnitType["stack"] = "stack";
    UnitType["temp"] = "temp";
    UnitType["tempFreezer"] = "tempFreezer";
    UnitType["tempFridge"] = "tempFridge";
    UnitType["tempHeating"] = "tempHeating";
    UnitType["tempInside"] = "tempInside";
    UnitType["tempOutside"] = "tempOutside";
    UnitType["tempPool"] = "tempPool";
    UnitType["tempSeaWater"] = "tempSeaWater";
    UnitType["tempWater"] = "tempWater";
    UnitType["tempWine"] = "tempWine";
    UnitType["timer"] = "timer";
    UnitType["toilet"] = "toilet";
    UnitType["unknown"] = "unknown";
    UnitType["virtual"] = "virtual";
    UnitType["virtualLogic"] = "virtualLogic";
    UnitType["virtualLostContact"] = "virtualLostContact";
    UnitType["virtualLostContactLocation"] = "virtualLostContactLocation";
    UnitType["virtualMotion"] = "virtualMotion";
    UnitType["virtualSmoke"] = "virtualSmoke";
    UnitType["virtualSurveillanceNotification"] = "virtualSurveillanceNotification";
    UnitType["virtualSurveillanceNotificationSmoke"] = "virtualSurveillanceNotificationSmoke";
    UnitType["virtualThreshold"] = "virtualThreshold";
    UnitType["virtualThresholdLower"] = "virtualThresholdLower";
    UnitType["virtualThresholdUpper"] = "virtualThresholdUpper";
    UnitType["volatileOrganicCompound"] = "volatileOrganicCompound";
    UnitType["washroom"] = "washroom";
    UnitType["weather"] = "weather";
    UnitType["wind"] = "wind";
    UnitType["zone"] = "zone";
})(UnitType = exports.UnitType || (exports.UnitType = {}));
//# sourceMappingURL=globalTypes.js.map